import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { TRANSITION_DURATION } from './RollupAnimation.constants';

interface RollupAnimationFrontProps {
  isOpen: boolean;
}

export const RollupAnimationFront = ({ children, isOpen }: React.PropsWithChildren<RollupAnimationFrontProps>) => (
  <Container
    height="100%"
    overflowY="auto"
    opacity={isOpen ? '1' : '0'}
    transition={`opacity ${TRANSITION_DURATION} ease-in-out, padding-bottom ${TRANSITION_DURATION} ease-in-out`}
  >
    {children}
  </Container>
);
